import {
  DialogTrigger,
  LinkButton,
  Popover,
  PopoverContent,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function BillingProfileWhatsThis() {
  const { t } = useTranslation();
  return (
    <DialogTrigger>
      <LinkButton testID="" textStyle="form/body-secondary-link">
        {t("What's this?")}
      </LinkButton>
      <Popover placement="top right">
        <PopoverContent>
          {t(
            "Your billing profile(s) gives you the ability to consolidate all billing onto one invoice OR separate out your billing onto multiple invoices in a given billing period. Your account requires at least one billing profile, which is set up when your account is created on CertnCentric. Select the Billing tab and then select Billing profiles to view current or create new Billing profiles."
          )}
        </PopoverContent>
      </Popover>
    </DialogTrigger>
  );
}
